module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic11.c060e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic11.png
// module id = 545
// module chunks = 1